namespace RedBullMOBILE360.PushNotifications {

    @Serenity.Decorators.registerClass('RedBullMOBILE360.PushNotifications.PushNotificationsDialog')
    export class PushNotificationsDialog extends Serenity.EntityDialog<PushNotificationsRow, any> {
        protected getFormKey() { return PushNotificationsForm.formKey; }
        protected getIdProperty() { return PushNotificationsRow.idProperty; }
        protected getLocalTextPrefix() { return PushNotificationsRow.localTextPrefix; }
        protected getNameProperty() { return PushNotificationsRow.nameProperty; }
        protected getService() { return PushNotificationsService.baseUrl; }
        protected getDeletePermission() { return PushNotificationsRow.deletePermission; }
        protected getInsertPermission() { return PushNotificationsRow.insertPermission; }
        protected getUpdatePermission() { return PushNotificationsRow.updatePermission; }

        protected form = new PushNotificationsForm(this.idPrefix);
    }
}